import { Component, OnInit } from "@angular/core";
import { Cloud, CloudService } from "src/app/shared/cloud/cloud.service";
import { Router } from "@angular/router";
import { RegionStorageService } from "src/app/shared/region/region-storage.service";
import { CloudIdStorageService } from "src/app/shared/cloud/cloud-id-storage.service";
import { tap, finalize } from "rxjs/operators";
import { TabSessionStorageService } from "src/app/shared/tabs/tab-session-storage.service";
import { CloudNameStorageService } from 'src/app/shared/cloud/cloud-name-storage.service';
import { BrowserInactivityService } from "src/app/service/browser-inactivity.service";
import { TimeoutStorageService } from "src/app/shared/timeout/timeout-storage.service";
import { CloudIsGovCloudStorageService } from "src/app/shared/cloud/cloud-is-gov-cloud-storage.service";
import { TermsAndConditions } from "src/app/shared/constants/terms-and-conditions";
import { UserMessageService } from "src/app/service/user-message.service";

@Component({
  standalone: false,
  selector: "app-clouds",
  templateUrl: "./clouds.component.html",
  styleUrls: ["./clouds.component.scss"],
})
export class CloudsComponent implements OnInit {
  clouds: Cloud[] = [];

  loading = false;

  loaded = false;

  showConfirmationBanner = false;

  selectedCloud: Cloud;

  fedRampMessage: string = TermsAndConditions.FedRAMPConfirmationMessage;

  constructor(
    private cloudService: CloudService,
    private regionStorageService: RegionStorageService,
    private timeoutStorageService: TimeoutStorageService,
    private cloudIdStorageService: CloudIdStorageService,
    private router: Router,
    private tabSessionStorageService: TabSessionStorageService,
    private cloudNameStorageService: CloudNameStorageService,
    private browserInactivityService:BrowserInactivityService,
    private cloudIsGovCloudService: CloudIsGovCloudStorageService,
    private userMessageService: UserMessageService

  ) {}

  ngOnInit() {
    this.loading = true;

    this.clearCloudId();
    this.clearRegion();
    this.clearCloudName();
    this.invalidateStoredTabSession();

    this.loadClouds()
      .pipe(
        tap(() => {
          this.loaded = true;
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe();
  }

  onCloudClick(cloud: Cloud) {
    this.userMessageService.changeMessage("");
    this.browserInactivityService.stop();
    this.browserInactivityService.loadBrowserInactivity(cloud.IdleTimeout)
    this.storeIdleTimeout(cloud.IdleTimeout);
    const cachedCloudId = this.cloudIdStorageService.loadCloudId();
    const cachedCloudIsGovCloud = this.cloudIsGovCloudService.loadCloudIsGovCloud();

    if (!cloud.IsGovCloud || (cloud.Id == cachedCloudId && cachedCloudIsGovCloud != null)) {
      this.navigateToCloud(cloud);
    } else {
      this.showConfirmationBanner = true;
      this.selectedCloud = cloud;
    }
  }

  navigateToCloud(cloud: Cloud) {
    this.storeRegion(cloud.Region);
    this.storeCloudId(cloud.Id);
    this.storeCloudName(cloud.Name);
    this.storeCloudIsGovCloud(cloud.IsGovCloud);
    this.invalidateStoredTabSession();
    return this.navigateByUrl("/features");
  }

  onConfirmNo() {
    this.showConfirmationBanner = false;
    this.selectedCloud = null;
  }

  loadClouds() {
    return this.getClouds().pipe(
      tap((cloud) => {
        this.clouds.push(cloud);
      })
    );
  }

  invalidateStoredTabSession() {
    return this.tabSessionStorageService.tabSession = null;
  }

  getClouds() {
    return this.cloudService.getClouds();
  }

  storeCloudId(cloudId) {
    this.cloudIdStorageService.storeCloudId(cloudId);
  }

  storeCloudName(v) {
    this.cloudNameStorageService.storeCloudName(v);
  }

  storeCloudIsGovCloud(isGovCloud: boolean) {
    this.cloudIsGovCloudService.storeCloudIsGovCloud(isGovCloud);
  }

  navigateByUrl(url) {
    return this.router.navigateByUrl(url);
  }

  storeIdleTimeout(idleTimeout) {
    this.timeoutStorageService.storeIdleTimeout(idleTimeout);
  }

  storeRegion(region) {
    this.regionStorageService.storeRegion(region);
  }

  clearRegion() {
    this.regionStorageService.clear();
  }

  clearCloudId() {
    this.cloudIdStorageService.clear();
  }

  clearCloudName() {
    this.cloudNameStorageService.clearCloudName();
  }
}
